export default __webpack_public_path__ + "static/media/brand.eba97663.png";